import script from "./pc-module-chi-square-analysis-6.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-chi-square-analysis-6.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-chi-square-analysis-6.vue?vue&type=style&index=0&id=cab3693c&lang=scss"

const __exports__ = script;

export default __exports__